import { IAPIParameters } from '@cian/mf-registry-legacy/browser';
import { getGlobalEventsLogs } from '@cian/events-log';
import { ensureHeaderMicrofrontend } from '../../microfrontend';
import { IOpenAuthModalParameters } from './types';

const TOPIC_USER = 'user';

export async function openAuthModal(parameters?: IOpenAuthModalParameters): Promise<void> {
  try {
    const microfrontend = await ensureHeaderMicrofrontend();

    if (microfrontend?.call) {
      return microfrontend.call('/v2/open-auth-modal/', parameters as IAPIParameters);
    }
  } catch {
    const globalLog = getGlobalEventsLogs();
    globalLog.produce(TOPIC_USER, {
      type: 'authenticate',
      value: {
        autoRefresh: false,
        source: parameters?.source ?? null,
      },
    });
  }
}
